import { FormContainer } from "@/components/form/FormContainer";
import { useOne } from "@refinedev/core";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { RESOURCE_TYPE_ADDON } from "@/resources-def";
import { Button, Space } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAddonVersionSchema } from "@/resources-def/addons-comp";
import { CreationWrapper } from "@/layouts/CreationWrapper";
import { useResourceCreate } from "@/hooks/useResourceCreate";
import { useResourceContext } from "@/layouts/ResourceContext";
import { omit } from "lodash";

const RESOURCE = RESOURCE_TYPE_ADDON;

export const AddonVersionCreator = ({id, version}) => {
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const navigateBack = useNavigate();
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedAddon] } = state;
  const { data, isLoading, isError } = useOne({
    resource: RESOURCE, 
    id: id,
    meta: { version: version },
  });
  const { mutateAsync, loading: isSaving } = useResourceCreate({
    resource: RESOURCE,
  });

  const rawSchema = getAddonVersionSchema(data?.type, true, false);

  const doCommit = async (values) => {
    await formRef.current?.validateFields();
    if(values.tableData) {
      values.requires = JSON.stringify(Object.values(values.tableData));
      delete values.tableData;
    }
    values.name = selectedAddon.name;
    const result = await mutateAsync({ values });
    if (result) {
      navigate({ resource: "settings/addons",  key: id, action: 'show' });
    } else {
      // TODO: show error message
    }
  };

  return (
    <CreationWrapper
      footer={
        <Space>
          <Button
            onClick={() => {
              navigate({ resource: "settings/addons",  key: id, action: 'show' });
            }}
          >
            Cancel
          </Button>
          <Button loading={isSaving} type="primary" onClick={() => formRef.current.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      {isLoading && <div>Loading...</div>}
      {!isLoading && (
        <FormContainer
          formRef={formRef}
          initValue={omit(data, ["version"])}
          schema={rawSchema}
          onFinishCallback={doCommit}
          style={{ paddingTop: 24 }}
          formItemLayout={{
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }}
        />
      )}
    </CreationWrapper>
  );
};
